import HelpIcon from '@mui/icons-material/Help';
import { Button, Container, styled } from '@mui/material';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Toolbar from '@mui/material/Toolbar';
import { useKeycloak } from '@react-keycloak/web';
import React, { useState } from 'react';
import { useUserRoles } from '../../hooks/useUserRoles';
import PublicRouter from '../../router/PublicRouter';
import RouterConfig from '../../router/RouterConfig';
import TalentRouterConfig from '../../router/TalentRouterConfig';
import Header from './Header';
import NavList from './NavList';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { LocalizationProvider } from '@mui/lab';
import enLocale from 'date-fns/locale/en-US';

const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
  open?: boolean;
}>(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  marginLeft: `-${drawerWidth}px`,
  backgroundColor: '#F6F7FB',
  minHeight: '100vh',
  paddingTop: '60px',
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: 0
  })
}));

const Layout = ({ loading }: { loading: boolean }): JSX.Element => {
  const [open, setOpen] = useState(true);
  const { isTalent } = useUserRoles();
  const { keycloak } = useKeycloak();

  const handleDrawer = () => {
    setOpen((prevState) => !prevState);
  };

  const currentRouterConfig = () => {
    return isTalent ? <TalentRouterConfig /> : <RouterConfig />;
  };

  return (
    <Box sx={{ display: 'flex' }}>
      {keycloak.authenticated && (
        <>
          <Header handleDrawer={handleDrawer} loading={loading} />
          <Drawer
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              '& .MuiDrawer-paper': {
                width: drawerWidth,
                boxSizing: 'border-box'
              }
            }}
            PaperProps={{
              sx: {
                bgcolor: '#EDF0F7'
              }
            }}
            color="primary"
            variant="persistent"
            open={open}
          >
            <Toolbar />
            <Box sx={{ overflow: 'auto', pt: 4 }}>
              <NavList />
            </Box>
          </Drawer>
          <Main open={open}>
            <Toolbar />
            <Container maxWidth="xl">
              <LocalizationProvider
                dateAdapter={AdapterDateFns}
                locale={enLocale}
              >
                {currentRouterConfig()}
              </LocalizationProvider>
            </Container>
            <Box display="flex" justifyContent="end">
              <Button
                sx={{ borderRadius: '48px', mr: 2, mt: 10 }}
                startIcon={<HelpIcon />}
              >
                Support
              </Button>
            </Box>
          </Main>
        </>
      )}
      {!keycloak.authenticated && <PublicRouter />}
    </Box>
  );
};

export default Layout;
